export default __webpack_public_path__ + "static/media/ad_weboffice_jp_300x250@2x.6267372b.png";